/* svelte-comps/VideoContainer.svelte generated by Svelte v3.59.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from 'svelte';
import moment from 'moment';
import Video from './Video';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[28] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[34] = list[i];
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[31] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[31] = list[i];
	return child_ctx;
}

// (120:0) {#if show_search}
function create_if_block_6(ctx) {
	let div1;
	let h5;
	let t1;
	let div0;
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			div1 = element("div");
			h5 = element("h5");
			h5.textContent = "Search";
			t1 = space();
			div0 = element("div");
			input = element("input");
			attr(input, "class", "video-search-input");
			attr(input, "type", "text");
			attr(div0, "class", "filter-input");
			attr(div1, "class", "filter-container");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, h5);
			append(div1, t1);
			append(div1, div0);
			append(div0, input);
			set_input_value(input, /*term*/ ctx[15]);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[24]),
					listen(input, "keyup", prevent_default(/*search*/ ctx[4]))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*term*/ 32768 && input.value !== /*term*/ ctx[15]) {
				set_input_value(input, /*term*/ ctx[15]);
			}
		},
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (162:0) {:else}
function create_else_block_2(ctx) {
	let h2;

	return {
		c() {
			h2 = element("h2");
			h2.textContent = "No videos match your filters";
		},
		m(target, anchor) {
			insert(target, h2, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h2);
		}
	};
}

// (134:0) {#if numVideos > 0}
function create_if_block_2(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_3, create_else_block_1];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (!/*show_categories*/ ctx[0]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (141:2) {:else}
function create_else_block_1(ctx) {
	let t0;
	let div;
	let a;
	let current;
	let mounted;
	let dispose;
	let each_value_2 = /*categoryVideos*/ ctx[14];
	let each_blocks = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t0 = space();
			div = element("div");
			a = element("a");
			a.textContent = "Show All Videos";
			attr(a, "href", "#all");
			attr(a, "class", "pow-button");
			attr(div, "class", "video-show-button");
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert(target, t0, anchor);
			insert(target, div, anchor);
			append(div, a);
			current = true;

			if (!mounted) {
				dispose = listen(a, "click", /*showAllVideos*/ ctx[9]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*categoryVideos, showCategoryVideos*/ 16640) {
				each_value_2 = /*categoryVideos*/ ctx[14];
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_2(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(t0.parentNode, t0);
					}
				}

				group_outros();

				for (i = each_value_2.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_2.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (135:2) {#if !show_categories}
function create_if_block_3(ctx) {
	let ul;
	let current;
	let each_value_1 = /*localVideos*/ ctx[13];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(ul, "class", "video-wrapper");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(ul, null);
				}
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty[0] & /*localVideos*/ 8192) {
				each_value_1 = /*localVideos*/ ctx[13];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (143:6) {#if category.videos.length > 0}
function create_if_block_4(ctx) {
	let div;
	let h2;
	let t0_value = /*category*/ ctx[34].name + "";
	let t0;
	let t1;
	let a;
	let t2;
	let a_href_value;
	let t3;
	let t4;
	let ul;
	let current;
	let mounted;
	let dispose;
	let if_block = /*category*/ ctx[34].description && create_if_block_5(ctx);
	let each_value_3 = /*category*/ ctx[34].videos;
	let each_blocks = [];

	for (let i = 0; i < each_value_3.length; i += 1) {
		each_blocks[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			div = element("div");
			h2 = element("h2");
			t0 = text(t0_value);
			t1 = space();
			a = element("a");
			t2 = text("Show All");
			t3 = space();
			if (if_block) if_block.c();
			t4 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(h2, "class", "category-name");
			attr(a, "href", a_href_value = '#' + /*category*/ ctx[34].slug);
			attr(a, "class", "show-more-button");
			attr(div, "class", "category-header");
			attr(ul, "class", "video-wrapper");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h2);
			append(h2, t0);
			append(div, t1);
			append(div, a);
			append(a, t2);
			insert(target, t3, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, t4, anchor);
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(ul, null);
				}
			}

			current = true;

			if (!mounted) {
				dispose = listen(a, "click", function () {
					if (is_function(/*showCategoryVideos*/ ctx[8](/*category*/ ctx[34].slug))) /*showCategoryVideos*/ ctx[8](/*category*/ ctx[34].slug).apply(this, arguments);
				});

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if ((!current || dirty[0] & /*categoryVideos*/ 16384) && t0_value !== (t0_value = /*category*/ ctx[34].name + "")) set_data(t0, t0_value);

			if (!current || dirty[0] & /*categoryVideos*/ 16384 && a_href_value !== (a_href_value = '#' + /*category*/ ctx[34].slug)) {
				attr(a, "href", a_href_value);
			}

			if (/*category*/ ctx[34].description) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_5(ctx);
					if_block.c();
					if_block.m(t4.parentNode, t4);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty[0] & /*categoryVideos*/ 16384) {
				each_value_3 = /*category*/ ctx[34].videos;
				let i;

				for (i = 0; i < each_value_3.length; i += 1) {
					const child_ctx = get_each_context_3(ctx, each_value_3, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_3(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				group_outros();

				for (i = each_value_3.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_3.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(t3);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t4);
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

// (148:8) {#if category.description}
function create_if_block_5(ctx) {
	let p;
	let raw_value = /*category*/ ctx[34].description + "";

	return {
		c() {
			p = element("p");
			attr(p, "class", "category-description");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			p.innerHTML = raw_value;
		},
		p(ctx, dirty) {
			if (dirty[0] & /*categoryVideos*/ 16384 && raw_value !== (raw_value = /*category*/ ctx[34].description + "")) p.innerHTML = raw_value;;
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (152:10) {#each category.videos as video}
function create_each_block_3(ctx) {
	let video;
	let current;

	video = new Video({
			props: {
				video: /*video*/ ctx[31],
				show_category: false
			}
		});

	return {
		c() {
			create_component(video.$$.fragment);
		},
		m(target, anchor) {
			mount_component(video, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const video_changes = {};
			if (dirty[0] & /*categoryVideos*/ 16384) video_changes.video = /*video*/ ctx[31];
			video.$set(video_changes);
		},
		i(local) {
			if (current) return;
			transition_in(video.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(video.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(video, detaching);
		}
	};
}

// (142:4) {#each categoryVideos as category}
function create_each_block_2(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*category*/ ctx[34].videos.length > 0 && create_if_block_4(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*category*/ ctx[34].videos.length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty[0] & /*categoryVideos*/ 16384) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_4(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (137:6) {#each localVideos as video}
function create_each_block_1(ctx) {
	let video;
	let current;

	video = new Video({
			props: {
				video: /*video*/ ctx[31],
				show_category: true
			}
		});

	return {
		c() {
			create_component(video.$$.fragment);
		},
		m(target, anchor) {
			mount_component(video, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const video_changes = {};
			if (dirty[0] & /*localVideos*/ 8192) video_changes.video = /*video*/ ctx[31];
			video.$set(video_changes);
		},
		i(local) {
			if (current) return;
			transition_in(video.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(video.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(video, detaching);
		}
	};
}

// (166:0) {#if show_pagination && numFilteredVids > per_page}
function create_if_block(ctx) {
	let div;
	let button0;
	let t0;
	let button0_disabled_value;
	let t1;
	let t2;
	let button1;
	let t3;
	let button1_disabled_value;
	let mounted;
	let dispose;
	let each_value = /*pages*/ ctx[16];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");
			button0 = element("button");
			t0 = text("Previous");
			t1 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			button1 = element("button");
			t3 = text("Next");
			attr(button0, "class", "pagination-btn previous");
			button0.disabled = button0_disabled_value = /*start*/ ctx[11] === 0;
			attr(button1, "class", "pagination-btn next");
			button1.disabled = button1_disabled_value = /*finish*/ ctx[12] >= /*numFilteredVids*/ ctx[10];
			attr(div, "class", "pagination-wrapper");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button0);
			append(button0, t0);
			append(div, t1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}

			append(div, t2);
			append(div, button1);
			append(button1, t3);

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*reverse*/ ctx[6]),
					listen(button1, "click", /*forward*/ ctx[5])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*start*/ 2048 && button0_disabled_value !== (button0_disabled_value = /*start*/ ctx[11] === 0)) {
				button0.disabled = button0_disabled_value;
			}

			if (dirty[0] & /*current_page, pages, per_page, setPage*/ 196738) {
				each_value = /*pages*/ ctx[16];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, t2);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty[0] & /*finish, numFilteredVids*/ 5120 && button1_disabled_value !== (button1_disabled_value = /*finish*/ ctx[12] >= /*numFilteredVids*/ ctx[10])) {
				button1.disabled = button1_disabled_value;
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (180:6) {:else}
function create_else_block(ctx) {
	let button;
	let t_value = /*page*/ ctx[28] / /*per_page*/ ctx[1] + 1 + "";
	let t;
	let mounted;
	let dispose;

	function click_handler_1() {
		return /*click_handler_1*/ ctx[26](/*page*/ ctx[28]);
	}

	return {
		c() {
			button = element("button");
			t = text(t_value);
			attr(button, "class", "pagination-btn");
			toggle_class(button, "active", /*current_page*/ ctx[17] === /*page*/ ctx[28] / /*per_page*/ ctx[1] + 1);
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);

			if (!mounted) {
				dispose = listen(button, "click", click_handler_1);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[0] & /*pages*/ 65536 && t_value !== (t_value = /*page*/ ctx[28] / /*per_page*/ ctx[1] + 1 + "")) set_data(t, t_value);

			if (dirty[0] & /*current_page, pages, per_page*/ 196610) {
				toggle_class(button, "active", /*current_page*/ ctx[17] === /*page*/ ctx[28] / /*per_page*/ ctx[1] + 1);
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (174:6) {#if page === 0}
function create_if_block_1(ctx) {
	let button;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[25](/*page*/ ctx[28]);
	}

	return {
		c() {
			button = element("button");
			button.textContent = "1";
			attr(button, "class", "pagination-btn");
			toggle_class(button, "active", /*current_page*/ ctx[17] === /*page*/ ctx[28] / /*per_page*/ ctx[1] + 1);
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (!mounted) {
				dispose = listen(button, "click", click_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*current_page, pages, per_page*/ 196610) {
				toggle_class(button, "active", /*current_page*/ ctx[17] === /*page*/ ctx[28] / /*per_page*/ ctx[1] + 1);
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (173:4) {#each pages as page}
function create_each_block(ctx) {
	let if_block_anchor;

	function select_block_type_2(ctx, dirty) {
		if (/*page*/ ctx[28] === 0) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type_2(ctx, [-1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_2(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let current_block_type_index;
	let if_block1;
	let t1;
	let if_block2_anchor;
	let current;
	let if_block0 = /*show_search*/ ctx[2] && create_if_block_6(ctx);
	const if_block_creators = [create_if_block_2, create_else_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*numVideos*/ ctx[18] > 0) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1]);
	if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block2 = /*show_pagination*/ ctx[3] && /*numFilteredVids*/ ctx[10] > /*per_page*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, t1, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*show_search*/ ctx[2]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block1 = if_blocks[current_block_type_index];

				if (!if_block1) {
					if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block1.c();
				} else {
					if_block1.p(ctx, dirty);
				}

				transition_in(if_block1, 1);
				if_block1.m(t1.parentNode, t1);
			}

			if (/*show_pagination*/ ctx[3] && /*numFilteredVids*/ ctx[10] > /*per_page*/ ctx[1]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(t1);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let categoryVideos;
	let numVideos;
	let current_page;
	const per_page = Number.MAX_SAFE_INTEGER;
	let { videos64, categories64, show_search, show_pagination, show_categories } = $$props;
	const videos = videos64 ? JSON.parse(atob(videos64)) : [];
	let categories = categories64 ? JSON.parse(atob(categories64)) : [];

	if (categories.length === 0) {
		show_categories = false;
	}

	let term = '';
	let filteredVideos = [...videos];
	let numFilteredVids = filteredVideos.length;
	let pages = [...Array(numFilteredVids).keys()].filter(n => n % per_page === 0);
	let start = 0;
	let finish = per_page;
	let localVideos = filteredVideos.slice(start, finish);

	const search = e => {
		$$invalidate(15, term = e.target.value.toLowerCase());
		$$invalidate(23, filteredVideos = videos.filter(v => v.post_title.toLowerCase().includes(term)));
		$$invalidate(13, localVideos = filteredVideos.slice(start, finish));
		$$invalidate(10, numFilteredVids = filteredVideos.length);
	};

	const forward = () => {
		if (finish < numFilteredVids) {
			setPage(start + per_page);
		}
	};

	const reverse = () => {
		if (start - per_page < 0) {
			setPage(0);
		} else {
			setPage(start - per_page);
		}
	};

	const scrollToTop = () => {
		let scroll_to = jQuery('#svelte-video-target').offset().top - 50;

		if (jQuery('#main-header').css('position') === 'fixed') {
			scroll_to -= jQuery('#main-header').outerHeight();
		}

		let current_scroll_top = jQuery(document).scrollTop();

		if (current_scroll_top > scroll_to) {
			jQuery('html, body').animate({ scrollTop: scroll_to }, Math.min(current_scroll_top - scroll_to, 1000));
		}
	};

	const setPage = new_start => {
		if (new_start === 0) {
			$$invalidate(11, start = 0);
			$$invalidate(12, finish = per_page);
		} else {
			$$invalidate(11, start = new_start);

			if (start + per_page > numFilteredVids) {
				$$invalidate(12, finish = numFilteredVids);
			} else {
				$$invalidate(12, finish = start + per_page);
			}
		}

		setTimeout(
			function () {
				// Scroll to the top of the videos when navigating, but account for the fixed header if necessary
				scrollToTop();
			},
			250
		);
	};

	const showCategoryVideos = slug => {
		const category = categories.find(category => category.slug === slug);

		if (category) {
			category.show_all = true;
		}

		$$invalidate(22, categories); // Noop to trigger svelte rerender
	};

	const showAllVideos = () => {
		$$invalidate(0, show_categories = false);

		setTimeout(
			function () {
				// Scroll to the top of the videos when navigating, but account for the fixed header if necessary
				scrollToTop();
			},
			250
		);
	};

	function input_input_handler() {
		term = this.value;
		$$invalidate(15, term);
	}

	const click_handler = page => setPage(page);
	const click_handler_1 = page => setPage(page);

	$$self.$$set = $$props => {
		if ('videos64' in $$props) $$invalidate(19, videos64 = $$props.videos64);
		if ('categories64' in $$props) $$invalidate(20, categories64 = $$props.categories64);
		if ('show_search' in $$props) $$invalidate(2, show_search = $$props.show_search);
		if ('show_pagination' in $$props) $$invalidate(3, show_pagination = $$props.show_pagination);
		if ('show_categories' in $$props) $$invalidate(0, show_categories = $$props.show_categories);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*filteredVideos, start, finish*/ 8394752) {
			$: $$invalidate(13, localVideos = filteredVideos.slice(start, finish));
		}

		if ($$self.$$.dirty[0] & /*show_categories, categories, filteredVideos*/ 12582913) {
			$: $$invalidate(14, categoryVideos = show_categories
			? categories.map(category => {
					let videos = filteredVideos.filter(video => video.category === category.slug);

					if (!category.show_all) {
						videos = videos.slice(0, 4);
					}

					return {
						name: category.name,
						description: category.description,
						slug: category.slug,
						videos
					};
				})
			: []);
		}

		if ($$self.$$.dirty[0] & /*show_categories, categoryVideos, localVideos*/ 24577) {
			$: $$invalidate(18, numVideos = show_categories
			? categoryVideos.reduce((acc, category) => acc + category.videos.length, 0)
			: localVideos.length);
		}

		if ($$self.$$.dirty[0] & /*numFilteredVids*/ 1024) {
			$: $$invalidate(16, pages = [...Array(numFilteredVids).keys()].filter(n => n % per_page === 0));
		}

		if ($$self.$$.dirty[0] & /*start*/ 2048) {
			$: $$invalidate(17, current_page = start / per_page + 1);
		}
	};

	return [
		show_categories,
		per_page,
		show_search,
		show_pagination,
		search,
		forward,
		reverse,
		setPage,
		showCategoryVideos,
		showAllVideos,
		numFilteredVids,
		start,
		finish,
		localVideos,
		categoryVideos,
		term,
		pages,
		current_page,
		numVideos,
		videos64,
		categories64,
		scrollToTop,
		categories,
		filteredVideos,
		input_input_handler,
		click_handler,
		click_handler_1
	];
}

class VideoContainer extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				per_page: 1,
				videos64: 19,
				categories64: 20,
				show_search: 2,
				show_pagination: 3,
				show_categories: 0,
				search: 4,
				forward: 5,
				reverse: 6,
				scrollToTop: 21,
				setPage: 7,
				showCategoryVideos: 8,
				showAllVideos: 9
			},
			null,
			[-1, -1]
		);
	}

	get per_page() {
		return this.$$.ctx[1];
	}

	get search() {
		return this.$$.ctx[4];
	}

	get forward() {
		return this.$$.ctx[5];
	}

	get reverse() {
		return this.$$.ctx[6];
	}

	get scrollToTop() {
		return this.$$.ctx[21];
	}

	get setPage() {
		return this.$$.ctx[7];
	}

	get showCategoryVideos() {
		return this.$$.ctx[8];
	}

	get showAllVideos() {
		return this.$$.ctx[9];
	}
}

export default VideoContainer;